/**
* @Author: zachalam
* @Date:   2017-01-19T15:59:47-08:00
* @Last modified by:   zachalam
* @Last modified time: 2017-01-23T14:22:41-08:00
*/



import React from 'react';
import {Route, IndexRoute} from 'react-router';

import AppContainer from './containers/AppContainer';
import AuthRequiredContainer from './containers/AuthRequiredContainer';
import NotFoundContainer from './containers/NotFoundContainer';

import DashboardContainer from './containers/DashboardContainer';
import SettingsContainer from './containers/SettingsContainer';
import BlockedContainer from './containers/BlockedContainer';
import DeactivateContainer from './containers/DeactivateContainer';
import FavoritesContainer from './containers/FavoritesContainer';
//import SearchContainer from './containers/SearchContainer';
import SearchHomeContainer from './containers/SearchHomeContainer';
import SearchResultsContainer from './containers/SearchResultsContainer';
import BillingContainer from './containers/BillingContainer';
import BillingOrderContainer from './containers/BillingOrderContainer';
import BillingSuccessContainer from './containers/BillingSuccessContainer';
import BillingPendingComponent from './components/pages/Billing/BillingPending';
import BillingHistoryContainer from './containers/BillingHistoryContainer';
import TripsContainer from './containers/TripsContainer';
import TripsCreateContainer from './containers/TripsCreateContainer';
import TripDetailsContainer from './containers/TripDetailsContainer';
import ProfileContainer from './containers/ProfileContainer';
import ProfileEditContainer from './containers/ProfileEditContainer';
import MailContainer from './containers/MailContainer';
import MsgConvoContainer from './containers/MsgConvoContainer';
import PhotosContainer from './containers/PhotosContainer';
import ReportContainer from './containers/ReportContainer';

/* login/logout/join routes */
import LoginContainer from './containers/LoginContainer';
import LogoutContainer from './containers/LogoutContainer';
import JoinS1Container from './containers/JoinS1Container';
import JoinS2Container from './containers/JoinS2Container';
import RestoringContainer from './containers/RestoringContainer';
import RestoreContainer from './containers/RestoreContainer';

import ContinueContainer from './containers/ContinueContainer';

/* GDPR */
import GdprContainer from './containers/GdprContainer';
import GdprViewContainer from './containers/GdprViewContainer';

export default (
  <Route path="/" component={AppContainer}>

    <IndexRoute component={LoginContainer} />
    <Route path="/continue" component={ContinueContainer} />

    <Route path="/login" component={LoginContainer} />
    <Route path="/logout" component={LogoutContainer} />
    <Route path="/join" component={JoinS1Container} />
    <Route path="/join-profile" component={JoinS2Container} />
    <Route path="/restoring" component={RestoringContainer} />
    <Route path="/restore" component={RestoreContainer} />

    <Route component={AuthRequiredContainer}>
      <Route path="/dashboard" component={DashboardContainer} />
      <Route path="/search" component={SearchHomeContainer} />
      <Route path="/search/results" component={SearchResultsContainer} />

      <Route path="/favorites" page="to" component={FavoritesContainer} />
      <Route path="/favorites/my" page="from" component={FavoritesContainer} />
      <Route path="/favorites/viewed" page="viewed" component={FavoritesContainer} />
      <Route path="settings" component={SettingsContainer} />
      <Route path="settings/privacy" page="privacy" component={SettingsContainer} />
      <Route path="settings/notifications" page="notifications" component={SettingsContainer} />
      <Route path="deactivate" component={DeactivateContainer} />
      <Route path="blocked" component={BlockedContainer} />
      <Route path="/report/:username" component={ReportContainer} />

      <Route path="/gdpr" component={GdprContainer} />
      <Route path="/gdpr/view" component={GdprViewContainer} />


      <Route path="/trips" component={TripsContainer} />
      <Route path="/trip/create" component={TripsCreateContainer} />
      <Route path="/trip/:tripID" component={TripDetailsContainer} />

      <Route path="/billing" component={BillingContainer} />
      <Route path="/billing/success" component={BillingSuccessContainer} />
      <Route path="/billing/pending" component={BillingPendingComponent} />
      <Route path="/billing/history" component={BillingHistoryContainer} />
      <Route path="/billing/:packageId" component={BillingOrderContainer} />

      <Route path="/profile" isMine={true} component={ProfileContainer} />
      <Route path="/profile/edit" isMine={true} component={ProfileEditContainer} />
      <Route path="/photos" component={PhotosContainer} />

      <Route path="~:username" component={ProfileContainer} />
      <Route path="/mail" page="inbox" component={MailContainer} />
      <Route path="/mail/sent" page="sentbox" component={MailContainer} />
      <Route path="/messages/:username" page="sentbox" component={MsgConvoContainer} />
      <Route path="*" component={NotFoundContainer}/>

    </Route>

    <Route path="*" component={NotFoundContainer}/>

  </Route>

);



// WEBPACK FOOTER //
// ./src/routes.js